import { Workbox } from 'workbox-window';
import { toast } from 'sonner';

/**
 * Register the service worker for PWA functionality.
 * - Never auto-reloads the page (that caused the "blink" on every deploy).
 * - When a new SW is waiting, shows a non-intrusive toast so the user can
 *   choose to refresh on their own time.
 */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator) || !import.meta.env.PROD) return;

  // Skip in iframes / Lovable preview hosts to avoid stale-cache issues.
  const inIframe = (() => {
    try { return window.self !== window.top; } catch { return true; }
  })();
  const isPreviewHost =
    typeof window !== 'undefined' &&
    (window.location.hostname.includes('id-preview--') ||
      window.location.hostname.includes('lovableproject.com') ||
      window.location.hostname.includes('lovable.app'));

  if (inIframe || isPreviewHost) {
    navigator.serviceWorker.getRegistrations().then((regs) =>
      regs.forEach((r) => r.unregister()),
    ).catch(() => {});
    return;
  }

  const wb = new Workbox('/sw.js');

  const promptToReload = () => {
    // Tell the waiting SW to take over, then reload after it activates.
    wb.addEventListener('controlling', () => {
      window.location.reload();
    });
    wb.messageSkipWaiting();
  };

  wb.addEventListener('waiting', () => {
    toast('A new version is available', {
      description: 'Refresh to get the latest improvements.',
      duration: Infinity,
      action: {
        label: 'Refresh',
        onClick: () => promptToReload(),
      },
    });
  });

  wb.register().catch(() => {
    /* swallow — SW failures should never break the app */
  });
}
